import { render, staticRenderFns } from "./PerformanceColumnView.vue?vue&type=template&id=59d5a776&scoped=true"
import script from "./PerformanceColumnView.vue?vue&type=script&lang=js"
export * from "./PerformanceColumnView.vue?vue&type=script&lang=js"
import style0 from "./PerformanceColumnView.vue?vue&type=style&index=0&id=59d5a776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5a776",
  null
  
)

export default component.exports